import React from 'react';
import Modal from '@purpose/ui/components/Modal/Modal';
import {useTranslations} from 'next-intl';
import {useRouter} from '../i18n/navigation';
import {IUnsavedChangesContext} from '../contexts/UnsavedChangesContext';
import {Typography} from '@purpose/ui/components';

const UnsavedChangesModal: React.FC<IUnsavedChangesContext> = ({
  link,
  setLink,
  open,
  setOpen,
  onSave
}) => {
  const t = useTranslations();
  const router = useRouter();

  const close = () => {
    setOpen(false);
    setLink(undefined);
  };

  const save = () => {
    if (onSave) {
      onSave();
    } else {
      if (link) router.push(link);
      else router.back();
    }
    setOpen(false);
    setLink(undefined);
  };

  return (
    <Modal
      open={open}
      onClose={close}
      onCancel={close}
      onSave={save}
      buttonTitle={t('General.unsaved.save')}
      cancelButtonTitle={t('General.unsaved.cancel')}
      title={t('General.unsaved.title')}
    >
      <Typography>{t('General.unsaved.description')}</Typography>
    </Modal>
  );
};

export default UnsavedChangesModal;
